var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-consumable-item-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2738f9fc!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-consumable-item-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterConsumableItemNew.vue
// module id = 632
// module chunks = 1